/**
 * Provider Subscriptions Module
 * Manages tier rules, status verification, and checkout redirect helpers.
 */

export const SUBSCRIPTION_PLANS = {
  FREE: { name: "Free Trial", price: 0, interval: "month", maxItems: 10 },
  BASIC: { name: "Basic Provider", price: 280, interval: "month", maxItems: 50 },
  PREMIUM: { name: "Premium Provider", price: 550, interval: "month", maxItems: 200 }
};

export const SVG_PAYMENT_POLICY = Object.freeze({
  launchCountry: "VC",
  clientOrderPaymentMethod: "cash",
  providerSubscriptionBilling: "stripe_when_configured",
  providerPayoutsEnabled: false
});

export class SubscriptionsModule {
  getPlanDetails(planId) {
    if (!planId) return SUBSCRIPTION_PLANS.FREE;
    const key = String(planId).toUpperCase();
    return SUBSCRIPTION_PLANS[key] || SUBSCRIPTION_PLANS.FREE;
  }

  getStripeRuntimeState(stripeConfig = {}) {
    const key = String(stripeConfig.publishableKey || "").trim();
    const placeholderValues = new Set(["", "replace-me", "demo", "example", "pk_test_placeholder", "pk_live_placeholder", "test"]);
    const mode = String(stripeConfig.mode || "sandbox").toLowerCase();
    const sandboxMode = mode === "sandbox" || mode === "test" || mode === "";
    const hasRealKey = key.length > 0 && !placeholderValues.has(key.toLowerCase());
    return {
      mode: sandboxMode ? "sandbox" : "live",
      hasRealKey,
      sandboxMode,
      enabled: hasRealKey && sandboxMode,
      isReadyForCheckout: hasRealKey && sandboxMode,
      isProductionSafe: hasRealKey && !sandboxMode
    };
  }

  isSubscriptionActive(provider) {
    if (!provider) return false;
    if (provider.subscriptionStatus === "active") return true;
    if (provider.subscriptionTier === "free" && provider.adminApproved) return true;
    return false;
  }

  isPaymentFlowReady(stripeConfig = {}) {
    return this.getStripeRuntimeState(stripeConfig).isReadyForCheckout;
  }

  getOrderPaymentMethod(countryCode) {
    return String(countryCode || "").toUpperCase() === SVG_PAYMENT_POLICY.launchCountry
      ? SVG_PAYMENT_POLICY.clientOrderPaymentMethod
      : null;
  }
}

export const subscriptionsModule = new SubscriptionsModule();
